var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeQuarters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 4.16663C13.5128 4.16663 4.16699 13.5125 4.16699 25C4.16699 36.4874 13.5128 45.8333 25.0003 45.8333C36.4878 45.8333 45.8337 36.4874 45.8337 25C45.8337 13.5125 36.4878 4.16663 25.0003 4.16663ZM22.728 7.95935C23.302 7.88328 23.8808 8.05787 24.3176 8.43807C24.7543 8.81828 25.0085 9.36826 25.0115 9.94723L25.0792 22.9736C25.0819 23.51 24.8708 24.0255 24.4925 24.4058C24.1142 24.7862 23.5997 25 23.0633 25H9.95955C9.37795 25 8.82476 24.7487 8.44194 24.311C8.05911 23.8732 7.88452 23.2914 7.96147 22.7149C8.98317 15.056 15.0673 8.97552 22.728 7.95935Z",
    fill: "#264653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeQuarters);
export default __webpack_public_path__ + "static/media/three-quarters.1566ee585f6c8308c270f12201df1a26.svg";
export { ForwardRef as ReactComponent };